import { Row, Col, Container, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import forklit from "../img/homepage/forklift-svgrepo-com.svg";
import gear from "../img/homepage/gear-svgrepo-com.svg";
import service from "../img/homepage/service-svgrepo-com.svg";
import medal from "../img/homepage/medal.svg"
import delivery from "../img/homepage/delivery-svgrepo-com.svg"
import shield from "../img/homepage/shield.svg"
import list from "../img/homepage/tag-svgrepo-com.svg"
import { useNavigate } from "react-router-dom";
import { FORKLIT_ROUTE, SERVICE_ROUTE, SHOP_ROUTE } from "../utils/consts";
import '../css/homepage.css';
import Ask from "../components/Ask"

const HomePage = () => {
    const navigate = useNavigate();
    return (
        <Container style={{maxWidth: 1200}}>
            <Row className="d-flex justify-content-center mb-5">
                <Col xs={12} md={8}>
                    <h1 className="homepage_h1">Запчасти для вилочных погрузчиков с доставкой по всей России!</h1>
                    <p className="homepage_p">Мы предлагаем широкий ассортимент запчастей для вилочных погрузчиков различных марок и моделей.</p>
                </Col>
            </Row>
            <Row xs={1} sm={1} md={2} lg={4} className="d-flex justify-content-center g-4">
                <Col className="d-flex justify-content-center">
                    <Card className="homepage_card">
                        <Card.Body>
                            <Card.Img className="homepage_gear_img" variant="top" src={gear} alt="Запчасти" />
                            <Card.Title className="card_title_homepage"><Link to={SHOP_ROUTE}>Запчасти для погрузчиков</Link></Card.Title>
                            <Card.Text>
                                <li style={{listStyle: "inside"}}>Широкий ассортимент запчастей</li>
                                <li style={{listStyle: "inside"}}>Качество и надежность</li>
                                <li style={{listStyle: "inside"}}>Доставка по всей России</li>
                                <li style={{listStyle: "inside"}}>Консультации специалистов</li>
                                <li style={{listStyle: "inside"}}>Оптимальные цены</li>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col className="d-flex justify-content-center">
                    <Card className="homepage_card">
                        <Card.Body>
                            <Card.Img className="homepage_forklit_img" variant="top" src={forklit} alt="Погрузчик" />
                            <Card.Title className="card_title_homepage"><Link to={FORKLIT_ROUTE}>Продажа вилочных погрусчиков</Link></Card.Title>
                            <Card.Text>
                                <li style={{listStyle: "inside"}}>Проведено полное ТО</li>
                                <li style={{listStyle: "inside"}}>Полностью готовые к работе</li>
                                <li style={{listStyle: "inside"}}>Есть как и новые так и б/у</li>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col className="d-flex justify-content-center">
                    <Card className="homepage_card">
                        <Card.Body>
                            <Card.Img className="homepage_forklit_img" variant="top" src={service} alt="Сервис" />
                            <Card.Title className="card_title_homepage"><Link to={SERVICE_ROUTE}>Сервис</Link></Card.Title>
                            <Card.Text>
                                <li style={{listStyle: "inside"}}>Выезжаем на диагностику</li>
                                <li style={{listStyle: "inside"}}>Работаем по всей Свердловской области</li>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Button className="button_rent" variant="custom" size="lg" onClick={() => navigate(SHOP_ROUTE)}>
                Перейти в каталог
            </Button>
            <Row className="d-flex justify-content-center mt-5">
                <Col xs={12} md={8}>
                    <h1 className="homepage_h1" style={{paddingBottom: 50}}>Наши преймущества</h1>
                </Col>
            </Row>
            <Row xs={1} sm={1} md={2} lg={2} className="d-flex justify-content-center g-4 pb-5">
                <Col className="d-flex justify-content-center">
                    <Card className="homepage_card_advantages">
                        <Card.Body className="d-flex">
                            <div className="image-column">
                                <Card.Img className="homepage_gear_img_advantages" src={medal} alt="Опыт" />
                            </div>
                            <div className="text-column">
                                <Card.Title className="card_title_homepage">Опыт работы</Card.Title>
                                <Card.Text>
                                    Более <b>20 лет</b> мы радуем своих клиентов быстрым и качественным обслуживаением
                                    Сотрудничествуем с надежными поставщиками по всей стране, что гарантирует низкую цену и отличное качевство для наших клиентов
                                </Card.Text>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col className="d-flex justify-content-center">
                    <Card className="homepage_card_advantages">
                        <Card.Body className="d-flex">
                            <div className="image-column">
                                <Card.Img className="homepage_gear_img_advantages" src={delivery} alt="Доставка" />
                            </div>
                            <div className="text-column">
                                <Card.Title className="card_title_homepage">Доставка</Card.Title>
                                <Card.Text>
                                    Осущевствляем доставку как и <b>погрузчиков</b>, так и <b>деталей</b> по всей стране
                                    Работаем с ведущими транспортными компаниями
                                </Card.Text>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row xs={1} sm={1} md={2} lg={2} className="d-flex justify-content-center g-4">
                <Col className="d-flex justify-content-center">
                    <Card className="homepage_card_advantages">
                        <Card.Body className="d-flex">
                            <div className="image-column">
                                <Card.Img className="homepage_gear_img_advantages" src={shield} alt="Гарантии" />
                            </div>
                            <div className="text-column">
                                <Card.Title className="card_title_homepage">Гарантии</Card.Title>
                                <Card.Text>
                                    Мы предоставляем гарантию <b>на все наши услуги</b>
                                        <br></br>
                                        Гарантия на сервисные услуги до 6 месяцев.
                                        Гарантия на детали от производителя.
                                    
                                </Card.Text>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col className="d-flex justify-content-center">
                    <Card className="homepage_card_advantages">
                        <Card.Body className="d-flex">
                            <div className="image-column">
                                <Card.Img className="homepage_gear_img_advantages" src={list} alt="Ассортимент" />
                            </div>
                            <div className="text-column">
                                <Card.Title className="card_title_homepage">Ассортимент</Card.Title>
                                <Card.Text>
                                    Работаем из наличия и под заказ.
                                    
                                        У нас один из самых <b>больших</b> ассортиментов деталей <b>в России</b>.
                                        Если вы не нашли деталь в нашем каталоге, мы привезем её специально для вас
                                    
                                </Card.Text>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Ask />
        </Container>
    );
}
export default HomePage;